/* eslint-disable no-redeclare */
import { z } from 'zod';

export const InsuranceForDto = z.enum([
  'me',
  'me_and_my_family',
  'my_business',
]);

export type InsuranceForDto = z.infer<typeof InsuranceForDto>;
